export const COMPETITION_FIELD_TYPE = {
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  DATE: 'DATE',
  ARRAY: 'ARRAY',
  BOOLEAN: 'BOOLEAN',
  CURRENCY: 'CURRENCY'
}

export const COMPETITION_SPECIAL_FILTER = {
  SPECIAL_FINANCE_DATA_FIELDS: ['revenueGrowthCheck', 'exportRevenueGrowthCheck'],
  SPECIAL_ANNUAL_DATA_FIELDS: ['annualExportRevenueCheck']
}
